// src/sectors/pilates/sessions/components/calendar/MobileDayList/parts/DayHeader.jsx
import React from 'react';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { MiniTag, toneColor } from '../mobileDayList.atoms';

export default function DayHeader({
  day,
  dayLabel,
  isToday,
  count,
  editMode,
  onCreateClick,
  tone = 'blue',
  isOpen = false, // ✅ yeni
  // ✅ yeni: akordiyon kontrolü
  onToggle,
}) {
  const handleToggle = () => onToggle?.();

  return (
    <MDBox
      onClick={handleToggle}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}
      sx={(t) => ({
        px: 1.05,
        py: 0.9,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        cursor: onToggle ? 'pointer' : 'default',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        borderRadius: 14,

        background:
          t.palette.mode === 'dark'
            ? alpha(toneColor(t, tone), isToday ? 0.12 : 0.06)
            : alpha(toneColor(t, tone), isToday ? 0.1 : 0.05),

        // mobil "press" hissi
        '&:active': onToggle
          ? {
              transform: 'scale(0.995)',
            }
          : undefined,
      })}
    >
      {/* LEFT */}
      <MDBox sx={{ minWidth: 0, display: 'grid', gap: 0.15 }}>
        <MDBox display="flex" alignItems="center" gap={0.7} sx={{ minWidth: 0 }}>
          {isToday ? (
            <MDBox
              sx={(t) => ({
                width: 9,
                height: 9,
                borderRadius: '999px',
                background: t.palette.info.main,
                boxShadow: `0 0 0 4px ${alpha(t.palette.info.main, 0.12)}`,
                flex: '0 0 auto',
              })}
            />
          ) : null}

          <MDTypography
            component="div"
            variant="button"
            fontWeight="bold"
            sx={{
              lineHeight: 1.05,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              fontSize: 13.5, // daha naif
            }}
          >
            {dayLabel}
          </MDTypography>

          {/* küçük chevron */}
          {onToggle ? (
            <Icon
              sx={(t) => ({
                fontSize: 18,
                opacity: 0.7,
                ml: 0.15,
                transition: 'transform 160ms ease',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                color: t.palette.text.secondary,
                flex: '0 0 auto',
              })}
            >
              expand_more
            </Icon>
          ) : null}
        </MDBox>

        <MDTypography
          component="div"
          variant="caption"
          sx={(t) => ({
            color: t.palette.text.secondary,
            lineHeight: 1.1,
            fontSize: 11.5,
            opacity: 0.9,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          })}
        >
          {String(day).slice(0, 10)}
        </MDTypography>
      </MDBox>

      {/* RIGHT */}
      <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
        <MiniTag icon="event" tone={count ? 'mint' : 'blue'} label={`${count} seans`} />

        {/* ✅ sadece dolu günlerde ok */}
        {count > 0 ? (
          <MDBox
            sx={(t) => ({
              width: 28,
              height: 28,
              borderRadius: '10px',
              display: 'grid',
              placeItems: 'center',
              border: `1px solid ${alpha(
                t.palette.text.primary,
                t.palette.mode === 'dark' ? 0.14 : 0.1
              )}`,
              background: alpha(t.palette.text.primary, t.palette.mode === 'dark' ? 0.06 : 0.04),
              opacity: 0.85,
              flex: '0 0 auto',
            })}
          >
            <Icon sx={{ fontSize: 18, opacity: 0.9 }}>
              {isOpen ? 'expand_more' : 'chevron_right'}
            </Icon>
          </MDBox>
        ) : null}

        {editMode ? (
          <Tooltip title="Seans ekle">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation(); // ✅ wrapper toggle'a gitmesin
                onCreateClick?.(e);
              }}
              sx={(t) => ({
                width: 36,
                height: 36,
                borderRadius: '12px',
                border: `1px solid ${alpha(
                  t.palette.text.primary,
                  t.palette.mode === 'dark' ? 0.16 : 0.12
                )}`,
                background: alpha(t.palette.success.main, 0.1),
              })}
            >
              <Icon sx={{ fontSize: 18, opacity: 0.9 }}>add</Icon>
            </IconButton>
          </Tooltip>
        ) : null}
      </MDBox>
    </MDBox>
  );
}
